import { ReactComponent as AUS } from "../../../assets/icons/Flags/AUS.svg";
import { ReactComponent as USA } from "../../../assets/icons/Flags/USA.svg";
import { ReactComponent as GBP } from "../../../assets/icons/Flags/GBP.svg";
import { ReactComponent as JPN } from "../../../assets/icons/Flags/JPN.svg";
import { ReactComponent as GBR } from "../../../assets/icons/Flags/GBR.svg";

const ccList = [
  { cc: "AUS", flag: <AUS /> },
  { cc: "USA", flag: <USA /> },
  { cc: "GBP", flag: <GBP /> },
  { cc: "GBR", flag: <GBR /> },
  { cc: "JPN", flag: <JPN /> },
];

export const getFlagSvg = (cc: string) => {
  try {
    const index = ccList.findIndex((item) => item.cc === cc);
    return ccList[index].flag;
  } catch (err) { }
};
